@if (_show) {
  <div class="drawer-backdrop" (click)="onClose()"></div>
}
<div class="drawer" [ngClass]="{ 'drawer--show': _show }">
  <header class="drawer__header">
    <button class="link-m drawer__header-close-btn" (click)="onClose()">
      <ac-icon size="small" name="close" />
      {{ 'NOTIFICATIONS.NOTIFICATIONS' | translate: { count: _unreadCountSig() } }}
    </button>
    @if (_headerMenuOptionsSig(); as menuOptions) {
      <ac-options-menu [options]="menuOptions" />
    }
  </header>
  <main class="drawer__body">
    @if (_show) {
      @if (_loadingSig()) {
        <ac-loading-panel />
      }
      <ac-notifications-list
        [notifications]="_notificationsSig()"
        [fullWidth]="true"
        [currentCategory]="_category"
        (clickedNotification)="onClose()"
      />
    }
  </main>
  <footer class="drawer__footer">
    <button primary-button class="w-full" (click)="onClickViewAll()">{{ 'NOTIFICATIONS.VIEW_ALL_NOTIFICATIONS' | translate }}</button>
  </footer>
</div>
